export default "__VITE_ASSET__Dyz47b$g__"